// extracted by mini-css-extract-plugin
module.exports = {"cls-1":"_3fXi2","crossIcon":"_1Kahe"};